import React from 'react';

import ForgotPasswordForm from 'components/ForgotPasswordForm';

import * as S from './styled';

const AuthorisedForgotPassword = () => {
    return (
        <S.ForgotPassContainer>
            <S.FormWrap>
                <ForgotPasswordForm />
            </S.FormWrap>
        </S.ForgotPassContainer>
    );
};

export default AuthorisedForgotPassword;
